import { render, staticRenderFns } from "./FctModal.vue?vue&type=template&id=b8edd84c"
import script from "./FctModal.vue?vue&type=script&lang=js"
export * from "./FctModal.vue?vue&type=script&lang=js"
import style0 from "./FctModal.vue?vue&type=style&index=0&id=b8edd84c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports